import HeartOutlined from '../src/HeartOutlined';
export default HeartOutlined;
